import { render, staticRenderFns } from "./LookCourseDetail.vue?vue&type=template&id=5021f5ae&scoped=true"
import script from "./LookCourseDetail.vue?vue&type=script&lang=js"
export * from "./LookCourseDetail.vue?vue&type=script&lang=js"
import style0 from "./LookCourseDetail.vue?vue&type=style&index=0&id=5021f5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5021f5ae",
  null
  
)

export default component.exports